import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { fadeInUp400ms } from '../../../../../../../@vex/animations/fade-in-up.animation';
import { stagger80ms } from '../../../../../../../@vex/animations/stagger.animation';
import { ALL_TEAMS, MockTeam } from '../../team-action-mock.data';

// Maquette d'estimation « action d'équipe » : fiche d'une équipe ouverte depuis le menu Équipes (données fictives).
@Component({
  selector: 'team-action-mock-team-page',
  templateUrl: './team-action-mock-team-page.component.html',
  animations: [fadeInUp400ms, stagger80ms],
})
export class TeamActionMockTeamPageComponent implements OnInit, OnDestroy {
  team?: MockTeam;
  private subscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.subscription = this.route.paramMap.subscribe(params => {
      this.team = ALL_TEAMS.find(team => team.id === params.get('teamId'));
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  backToList(): void {
    this.router.navigate(['/management/teams']);
  }
}
